import { remCalc } from "./utils";

const overline1 = {
  fontSize: "brand.xs",
  lineHeight: "16",
  letterSpacing: remCalc(0.88),
  textTransform: "uppercase",
};

const overline2 = {
  fontSize: "brand.2xs",
  lineHeight: "14",
  letterSpacing: remCalc(0.825),
  textTransform: "uppercase",
};

const caption1 = {
  fontSize: "brand.sm",
  lineHeight: "20",
  letterSpacing: remCalc(0.363),
};

const caption2 = {
  fontSize: "brand.xs",
  lineHeight: "16",
  letterSpacing: remCalc(0.385),
};

const body1 = {
  fontSize: "brand.xl",
  lineHeight: "32",
  letterSpacing: remCalc(-0.114),
};

const body2 = {
  fontSize: "brand.lg",
  lineHeight: "28",
};

const body3 = {
  fontSize: "brand.md",
  lineHeight: "24",
  letterSpacing: remCalc(0.087),
};

const headline1 = {
  fontSize: "brand.3xl",
  lineHeight: "40",
  fontWeight: "bold",
  letterSpacing: remCalc(-0.493),
};
const headline2 = {
  fontSize: "brand.2xl",
  lineHeight: "32",
  fontWeight: "bold",
  letterSpacing: remCalc(-0.342),
};
const headline3 = {
  fontSize: "brand.lg",
  lineHeight: "24",
  fontWeight: "bold",
  letterSpacing: remCalc(-0.19),
};
const display1 = {
  fontSize: "brand.7xl",
  lineHeight: "72",
  fontWeight: "bold",
  letterSpacing: remCalc(-2.043),
};
const display2 = {
  fontSize: "brand.6xl",
  lineHeight: "64",
  fontWeight: "bold",
  letterSpacing: remCalc(-1.703),
};
const display3 = {
  fontSize: "brand.5xl",
  lineHeight: "56",
  fontWeight: "bold",
  letterSpacing: remCalc(-0.946),
};
const article = {
  fontFamily: "inter",
  fontSize: "brand.md",
  lineHeight: "28",
  letterSpacing: "normal",
};

const poster1 = {
  fontSize: remCalc(136),
  lineHeight: remCalc(120),
  fontWeight: "bold",
  letterSpacing: remCalc(-4.2),
};

const poster2 = {
  fontSize: remCalc(116),
  lineHeight: remCalc(96),
  fontWeight: "bold",
  letterSpacing: remCalc(-3.1),
};

const poster3 = {
  fontSize: remCalc(92),
  lineHeight: remCalc(84),
  fontWeight: "bold",
  letterSpacing: remCalc(-2.001),
};

export const textStyles = {
  overline1,
  overline2,
  caption1,
  caption2,
  body1,
  body2,
  body3,
  headline1,
  headline2,
  headline3,
  display1,
  display2,
  display3,
  poster1,
  poster2,
  poster3,
  article: {
    h1: {
      ...display2,
      fontFamily: "inter",
      letterSpacing: "normal",
    },
    h2: {
      ...display3,
      fontSize: "brand.4xl",
      lineHeight: "48",
      fontFamily: "inter",
      letterSpacing: "normal",
      mt: "biggest",
      mb: "bigger",
      // Remove top margin if the article begins with an h2 and no other elements come before it.
      _first: {
        "&:not(* + h2)": { mt: 0 },
      },
    },
    h3: {
      ...headline1,
      fontFamily: "inter",
      letterSpacing: "normal",
      mt: "biggest",
      mb: "bigger",
    },
    h4: {
      ...headline2,
      fontFamily: "inter",
      letterSpacing: "normal",
      mt: "biggest",
      mb: "big",
    },
    h5: {
      ...headline3,
      fontFamily: "inter",
      letterSpacing: "normal",
      mt: "bigger",
      mb: "big",
    },
    p: {
      ...article,
      mb: "big",
    },
    footer: {
      ...caption1,
      letterSpacing: "normal",
      fontFamily: "inter",
      mt: "big",
    },
    list: {
      ...article,
      spacing: "smallest",
      mb: "big",
      mt: "calc(var(--chakra-space-smaller) * -1)",
      ml: "smallest",
      "& ul, & ol": {
        mt: "tiny",
        mb: "0",
      },
    },
    listItem: {
      ...article,
      mb: "smaller",
      ".article-footer &": {
        ...caption1,
      },
    },
  },
  /**-----------------------------------
   * Legacy text styles
   *-----------------------------------*/
  h1: {
    fontFamily: "heading",
    fontSize: ["5xl", "6xl", "7xl", "8xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  h2: {
    fontFamily: "heading",
    fontSize: ["4xl", "5xl", "5xl", "6xl", "7xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  h3: {
    fontFamily: "heading",
    fontSize: ["4xl", "4xl", "4xl", "5xl", "6xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  h4: {
    fontFamily: "heading",
    fontSize: ["3xl", "3xl", "3xl", "4xl", "5xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  h5: {
    fontFamily: "heading",
    fontSize: ["xl", "2xl", "2xl", "3xl", "4xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  h6: {
    fontFamily: "heading",
    fontSize: ["xl", "xl", "2xl", "2xl", "3xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  h7: {
    fontFamily: "heading",
    fontSize: ["lg", "xl", "xl", "2xl", "2xl"],
    fontWeight: "semibold",
    lineHeight: "1.25",
  },
  e3: {
    fontFamily: "heading",
    fontSize: ["2xl", "2xl", "2xl", "3xl", "3xl"],
    fontWeight: "semibold",
    lineHeight: "1.35",
  },
  e4: {
    fontFamily: "heading",
    fontSize: ["lg", "xl"],
    fontWeight: "semibold",
    lineHeight: "1.35",
  },
  p: {
    marginBottom: 4,
  },
  table: {
    fontFamily: "heading",
  },
  uppercase: {
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  uppercaseLight: {
    fontWeight: "semibold",
    textTransform: "uppercase",
    letterSpacing: 1,
  },
};
